<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="desserts"
      sort-by="calories"
      class="elevation-1"
      :page.sync="page"
      :items-per-page="itemsPerPage"
      hide-default-footer
      :search="search"
      @page-count="pageCount = $event"
    >
      <template v-slot:item.disabled="{ item }">
        <v-chip
          :color="getColor(item.disabled)"
          dark
        >
          {{ item.disabled }}
        </v-chip>
      </template>
      <template v-slot:top>
        <v-toolbar
          flat
        >
          <v-toolbar-title>角色管理</v-toolbar-title>
          <v-divider
            class="mx-4"
            inset
            vertical
          />
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            clearable
            single-line
            hide-details
          />
          <v-spacer />
          <v-dialog
            v-model="dialog"
            max-width="500px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="primary"
                dark
                class="mb-2"
                v-bind="attrs"
                v-on="on"
              >
                添加
              </v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span class="headline">{{ formTitle }}</span>
              </v-card-title>

              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col
                      cols="24"
                      sm="12"
                      md="12"
                    >
                      <v-text-field
                        v-model="editedItem.guard_name"
                        :rules="guardRules"
                        label="角色标示"
                        onlyread
                        required
                      />
                    </v-col>
                    <v-col
                      cols="24"
                      sm="12"
                      md="12"
                    >
                      <v-text-field
                        v-model="editedItem.name"
                        :rules="nameRules"
                        label="角色名称"
                        required
                      />
                    </v-col>
                    <v-col
                      cols="24"
                      sm="12"
                      md="12"
                    >
                      <v-textarea
                        v-model="editedItem.description"
                        auto-grow
                        label="描述"
                        rows="2"
                      />
                    </v-col>
                    <v-col
                      cols="24"
                      sm="12"
                      md="12"
                    >
                      <v-radio-group
                        v-model="editedItem.disabled"
                        row
                      >
                        <v-radio
                          label="启用"
                          value="1"
                        />
                        <v-radio
                          label="禁用"
                          value="0"
                        />
                      </v-radio-group>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer />
                <v-btn
                  @click="close"
                >
                  取消
                </v-btn>
                <v-btn
                  color="success"
                  @click="save"
                >
                  保存
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog
            v-model="dialogDelete"
            max-width="300px"
          >
            <v-card>
              <v-card-title
                class="headline"
              >
                请确认是否删除?
              </v-card-title>
              <v-card-actions>
                <v-spacer />
                <v-btn
                  color="blue darken-1"
                  text
                  @click="closeDelete"
                >
                  取消
                </v-btn>
                <v-btn
                  color="blue darken-1"
                  text
                  @click="deleteItemConfirm"
                >
                  确定
                </v-btn>
                <v-spacer />
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template
        v-slot:item.actions="{ item }"
      >
        <v-icon
          small
          class="mr-2"
          @click="editItem(item)"
        >
          mdi-pencil
        </v-icon>
        <v-icon
          small
          @click="deleteItem(item)"
        >
          mdi-delete
        </v-icon>
      </template>
      <template v-slot:no-data>
        <v-btn
          color="primary"
          @click="initialize"
        >
          Reset
        </v-btn>
      </template>
    </v-data-table>
    <div class="text-center pt-2">
      <v-pagination
        v-model="page"
        :length="pageCount"
      />
      <!--<v-text-field
        :value="itemsPerPage"
        label="Items per page"
        type="number"
        min="-1"
        max="15"
        @input="itemsPerPage = parseInt($event, 10)"
      />-->
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  export default {
    name: 'RolesView',
    data: () => ({
      radios: 1,
      search: '',
      dialog: false,
      dialogDelete: false,
      page: 1,
      pageCount: 0,
      itemsPerPage: 12,
      headers: [
        {
          text: 'ID',
          align: 'start',
          value: 'id',
        },
        { text: '标示', value: 'guard_name' },
        { text: '名称', value: 'name', sortable: false },
        { text: '描述', value: 'description', sortable: false },
        { text: '状态', value: 'disabled' },
        { text: '操作', value: 'actions', sortable: false },
      ],
      desserts: [],
      editedIndex: -1,
      editedItem: {
        guard_name: '',
        name: '',
        description: '',
        disabled: '1',
      },
      defaultItem: {
        guard_name: '',
        name: '',
        description: '',
        disabled: '1',
      },
      guardRules: [
        v => !!v || '角色标示不能为空',
      ],
      nameRules: [
        v => !!v || '角色名称不能为空',
      ],
    }),

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? '新建' : '编辑'
      },
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },
    },

    created () {
      this.initialize()
    },

    methods: {
      initialize () {
        axios
          .get(process.env.VUE_APP_BASE_API + '/role/roles')
          .then(response => {
            if (response.status === 200) {
              this.desserts = response.data.data
              this.desserts.map((item, i, arr) => {
                if (item.disabled === 1) {
                  item.disabled = '启用'
                } else {
                  item.disabled = '禁用'
                }
              })
              // console.log(this.desserts)
            }
          })
          .catch(error => {
            console.log(error)
          })
      },

      editItem (item) {
        this.editedIndex = this.desserts.indexOf(item)
        // console.log(item)
        this.editedItem = Object.assign({}, item)
        this.editedItem.disabled = (this.editedItem.disabled === '启用') ? '1' : '0'
        // this.editedItem.disabled.toString()
        this.dialog = true
      },

      deleteItem (item) {
        this.editedIndex = this.desserts.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },

      deleteItemConfirm () {
        axios
          .delete(process.env.VUE_APP_BASE_API + '/role/destroy/' + this.editedItem.id)
          .then(response => {
            if (response.data.code === 20000) {
              this.desserts.splice(this.editedIndex, 1)
            }
          })
          .catch(error => {
            console.log(error)
          })
        this.closeDelete()
      },

      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      save () {
        const item = this.editedItem
        const _editedIndex = this.editedIndex
        const url = this.editedIndex === -1 ? process.env.VUE_APP_BASE_API + '/role/role' : process.env.VUE_APP_BASE_API + '/role/update/' + item.id
        axios
          .post(url, this.editedItem)
          .then(response => {
            if (response.data.code === 20000) {
              item.disabled = (this.editedItem.disabled === '1') ? '启用' : '禁用'
              item.id = response.data.data
              if (_editedIndex > -1) {
                Object.assign(this.desserts[_editedIndex], item)
              } else {
                this.desserts.push(item)
              }
            }
          })
          .catch(error => {
            console.log(error)
          })
        this.close()
      },

      getColor (calories) {
        if (calories === '启用') return 'green'
        else return 'red'
      },

    },
  }
</script>
